export default "__VITE_ASSET__363adb05__"